import _ from 'underscore';
import React from 'react';
import cx from 'classnames';
import { getEntityUrl } from '@culture/common-helpers/cultureUtils';
import { filterParticipants } from '@culture/utils/helpers/entities';

import CommonPropTypes from 'utils/propTypes/common';

import BasePreview from '../BasePreview';

import styles from './styles.module.scss';

const MoviePreview = ({ data, ...props }) => {
	const {
		institute,
		genres,
		year,
		duration,
		shortText,
		participants,
		type
	} = data;
	const movieUrl = getEntityUrl('movies', data);
	const genre = _(['movie', 'performance']).contains(type) && genres[0]?.title;
	const instituteUrl =
		(type === 'concert' || type === 'performance') &&
		institute?.status === 'published' &&
		getEntityUrl('institutes', institute);
	const lecturers =
		type === 'lecture' &&
		participants &&
		filterParticipants(participants, 'lecturer');

	const attributes = _.compact([
		genre,
		year,
		duration && `${Math.ceil(duration / 60)} мин`,
		lecturers && _(lecturers).pluck('title').join(', ')
	]);

	return (
		<BasePreview
			data={data}
			url={movieUrl}
			subtitle={
				<div>
					<div className={styles.list}>
						{attributes.map((attribute) => (
							<span key={attribute} className={styles.item}>
								{attribute}
							</span>
						))}
						{institute && (
							<span className={cx(styles.item, styles.normal)}>
								{instituteUrl ? (
									<a className={styles.link} href={instituteUrl}>
										{institute.title}
									</a>
								) : (
									institute.title
								)}
							</span>
						)}
					</div>
					{shortText && <div className={styles.text}>{shortText}</div>}
				</div>
			}
			{...props}
		/>
	);
};

MoviePreview.propTypes = {
	data: CommonPropTypes.entity.isRequired
};

export default MoviePreview;
